export default __webpack_public_path__ + "static/media/menu-cloud-icon.5af9119d.svg";